import { useAuth } from '../modules/auth/hooks/useAuth';

export function SidebarUser() {
  const { user } = useAuth();
  if (!user) return null;

  const initial = user.displayName
    ? user.displayName.charAt(0).toUpperCase()
    : user.email.charAt(0).toUpperCase();

  return (
    <div className="border-t border-gray-700 px-3 py-3">
      <div className="flex items-center gap-3">
        <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-blue-600">
          <span className="text-sm font-bold text-white">{initial}</span>
        </div>
        <div className="min-w-0">
          <p className="truncate text-sm font-medium text-white">
            {user.displayName || 'ユーザー'}
          </p>
          <p className="truncate text-xs text-gray-400">{user.email}</p>
        </div>
      </div>
    </div>
  );
}
